import * as React from 'react'; 
import { DataItem, Translation } from '../../../models/models';
import { RES_URL } from '../../../config';
import { LANG } from '../../../constants';


export interface MenuProps{
    className?:string;
    isOpen: boolean;
    dataset: DataItem[];
    goToImg: (idx:number) => void;
    closeMenu: () => void;
    locale: Translation;
    currentImgIdx: number;
}

export interface MenuState{

}

export class Menu extends React.Component<MenuProps, MenuState>{
    el:HTMLDivElement;
    constructor(p:MenuProps){
        super(p);
    }

    onClick = (idx:number) => {
        this.props.goToImg(idx);
        this.props.closeMenu();
    }

    render(){
        let props = this.props, 
            state = this.state,
            cls = this.props.className || "";
            
        return (
            <div className={"menu " + cls} ref={e=> this.el= e}>
                <div className="menu__line top"></div>
                <div className="menu__line bottom"></div>
                <div className="menu__line black"></div>
                <div className={`menu__campaign-logo ${LANG}`}>
                    <a href={`${RES_URL}`}>
                        <img src={`${RES_URL}img/${LANG}/campaign-logo.svg`} alt={props.locale.campaignName}/>
                    </a>
                </div>
                <ul className="menu__list">
                {
                    props.dataset.length > 0 && props.dataset.map((val, i) => (
                        <li className={`menu__item ${props.currentImgIdx === val.order - 1 ? "selected" : ""}`} key={val.key}
                            onClick={() => this.onClick(val.order - 1)}
                        >
                            <p>{`${val.name} ${val.year} & 2018`}</p>
                        </li>
                    ))
                }
                </ul>
            </div>
        )
    }
}


// WEBPACK FOOTER //
// ./src/components/ui/Menu/Menu.tsx